const translations = {
  "en": {
    "Searching for": "Searching for",
    "see %{var0} more": "see %{var0} more"
  },
  "zh-tw": {
    "Searching for": "正在搜尋",
    "see %{var0} more": "查看更多 %{var0}"
  }
};

export default translations;
